import React, { Fragment } from 'react'
import classNames from 'classnames'
import { map, toPairs } from 'lodash/fp'

import styles from './interpolateStrong.module.css'

/* eslint-disable react/display-name */
export default function interpolateStrong({
  className,
  interpolate = true,
  tag,
}: {
  className?: string
  interpolate?: boolean
  tag?: string
} = {}) {
  return {
    [tag || 'strong']: (...chunks: string[]) =>
      interpolate ? (
        <span className={classNames(styles.strong, className)}>
          {map(
            ([index, chunk]) => (
              <Fragment key={index}>{chunk}</Fragment>
            ),
            toPairs(chunks),
          )}
        </span>
      ) : (
        chunks
      ),
  }
}
